// v2
/*
import fotoliste_v2 from '../scheme-v2/fotoliste';
import befundbeschreibung_v2 from '../scheme-v2/befundbeschreibung';
import fundliste_v2 from '../scheme-v2/fundliste';
import planumsbeschreibung_v2 from '../scheme-v2/planumsbeschreibung';
import probenliste_v2 from '../scheme-v2/probenliste';
import profilbeschreibung_v2 from '../scheme-v2/profilbeschreibung';
import skelettbeschreibung_v2 from '../scheme-v2/skelettbeschreibung';
import testfile_v2 from '../scheme-v2/testfile';
import metadaten_vorgangsnr_v2 from '../scheme-v2/metadaten_vorgangsnr';
*/

// v3
/*
import befundbeschreibung_v3 from '../scheme-v3/befundbeschreibung';
import fotoliste_v3 from '../scheme-v3/fotoliste';
import fundliste_v3 from '../scheme-v3/fundliste';
import planumsbeschreibung_v3 from '../scheme-v3/planumsbeschreibung';
import probenliste_v3 from '../scheme-v3/probenliste';
import profilliste_v3 from '../scheme-v3/profilliste';
import profilbeschreibung_v3 from '../scheme-v3/profilbeschreibung';
import skelettbeschreibung_v3 from '../scheme-v3/skelettbeschreibung';
import testfile_v3 from '../scheme-v3/testfile';
*/

// v4
import befundbeschreibung_v4 from '../scheme-v4/befundbeschreibung';
import fotoliste_v4 from '../scheme-v4/fotoliste';
import fundliste_v4 from '../scheme-v4/fundliste';
import planumsbeschreibung_v4 from '../scheme-v4/planumsbeschreibung';
import probenliste_v4 from '../scheme-v4/probenliste';
import profilliste_v4 from '../scheme-v4/profilliste';
import profilbeschreibung_v4 from '../scheme-v4/profilbeschreibung';
import skelettbeschreibung_v4 from '../scheme-v4/skelettbeschreibung';


const register = {
	"Befundbeschreibung"  : befundbeschreibung_v4,
	"Fotoliste"           : fotoliste_v4,
	"Fundliste"           : fundliste_v4,
	"Planumsbeschreibung" : planumsbeschreibung_v4,
	"Probenliste"         : probenliste_v4,
	"Profilliste"         : profilliste_v4,
	"Profilbeschreibung"  : profilbeschreibung_v4,
	"Skelettbeschreibung" : skelettbeschreibung_v4,
};

export default register;
